import * as universal from '../entries/pages/blog/_page.ts.js';
import stylesheet_4 from '../stylesheets/4.js';
import stylesheet_6 from '../stylesheets/6.js';
import stylesheet_17 from '../stylesheets/17.js';
import stylesheet_8 from '../stylesheets/8.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/blog/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/blog/+page.ts";
export const imports = ["_app/immutable/nodes/5.fbcae3fd.js","_app/immutable/chunks/BlogContentCard.05febddf.js","_app/immutable/chunks/control.f5b05b5f.js","_app/immutable/chunks/scheduler.2887eafe.js","_app/immutable/chunks/index.387b3ba3.js","_app/immutable/chunks/each.77017db3.js","_app/immutable/chunks/index.544ab3ce.js","_app/immutable/chunks/Wrapper.6637e6f2.js","_app/immutable/chunks/Input.81ed72a4.js"];
export const stylesheets = ["_app/immutable/assets/5.698818b7.css","_app/immutable/assets/BlogContentCard.ad128bc8.css","_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Input.8fc26899.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/5.698818b7.css": stylesheet_4,
	"_app/immutable/assets/BlogContentCard.ad128bc8.css": stylesheet_6,
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_17,
	"_app/immutable/assets/Input.8fc26899.css": stylesheet_8
});
